import TaxiCorporationFleetPartnerUpdateRequest from "../../../../api/raily/taxi-corporation/fleet-partner/update/taxi-corporation-fleet-partner-update.request";
import TaxiCorporationFleetPartnerUpdateParams from "./taxi-corporation-fleet-partner-update-params";

const create = (
  params: TaxiCorporationFleetPartnerUpdateParams,
): TaxiCorporationFleetPartnerUpdateRequest => {
  return {
    taxiCorporationId: params.taxiCorporationUuid,
    fleetPartnerId: params.fleetPartnerUuid,
    name: params.name,
    notes: params.notes,
  };
};

const taxiCorporationFleetPartnerUpdateParamsFactory = { create };

export default taxiCorporationFleetPartnerUpdateParamsFactory;
